import styled from 'styled-components';

export const TooltipContainer = styled.div`
  position: absolute;
  width: ${props => (props.isBillsTooltip && props.isMobile ? '200px' : props.isBillsTooltip ? '400px' : 'auto')};
  min-width: 200px;
  max-width: ${props => (props.isBillsTooltip && props.isMobile ? '200px' : props.isBillsTooltip ? '400px' : '200px')};
  word-wrap: no-wrap;
  transform: ${props => (props.isBillsTooltip && props.isMobile ? 'translate(-30%)' : 'translate(-50%)')};
  transform-style: preserve-3d;
  z-index: var(--zIndex, 1);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  border-radius: 5px;
  background-color: ${props => props.theme.backgrounds.shuttleGray};
  top: ${props => (props.bottom ? '35px' : 'auto')};
  bottom: ${props => (props.bottom ? 'auto' : 'calc(100% + 16px)')};
  left: 50%;
  font-size: 16px;
  display: none;

  &:after {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    transform-origin: 50% 50%;
    transform: rotate(45deg) translateX(-50%);
    background-color: ${props => props.theme.backgrounds.shuttleGray};
    top: ${props => (props.bottom ? '-1px' : '98%')};
    left: 50%;
    z-index: calc(var(--zIndex, 1) + 1);
    display: block;
  }

  &:before {
    content: ${props => (props.bottom ? '' : 'none')};
    position: absolute;
    width: 10px;
    height: 10px;
    transform-origin: 50% 50%;
    transform: rotate(45deg) translateX(-50%) translateZ(-1px);
    background-color: ${props => props.theme.backgrounds.shuttleGray};
    top: 0px;
    left: 50%;
    z-index: -1;
    box-shadow: -1px -1px 20px #aaa;
    display: block;
  }
`;

export const TooltipWrapper = styled.div`
  position: relative;

  &:hover {
    ${TooltipContainer} {
      display: block;
    }
  }
`;

export const TooltipContent = styled.span`
  display: block;
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  font-size: ${props => props.theme.rem(14)};
  margin: 10px;
  color: ${props => props.theme.typography.invertedColor};
`;
